import { defineMessages } from 'react-intl';

export default defineMessages({
    returnedContentP: {
        id: 'ml.gateway.quoteandbind.pa.prefill.returnedContentP',
        defaultMessage: 'The below drivers and vehicles have been returned. Please review to make sure this is correct.'
    },
    driversNext: {
        id: 'ml.gateway.quoteandbind.pa.prefill.driversNext',
        defaultMessage: 'Next, we\'ll work on your {drivers}'
    },
    drivers: {
        id: 'ml.gateway.quoteandbind.pa.prefill.drivers',
        defaultMessage: 'drivers'
    },
    driverSectionHeader: {
        id: 'ml.gateway.quoteandbind.pa.prefill.driverSectionHeader',
        defaultMessage: 'Drivers'
    },
    noDriversP: {
        id: 'ml.gateway.quoteandbind.pa.prefill.noDriversP',
        defaultMessage: 'No drivers are currently covered on this quote. Please add the drivers now.'
    },
    name: {
        id: 'ml.gateway.quoteandbind.pa.prefill.name',
        defaultMessage: 'name'
    },
    dob: {
        id: 'ml.gateway.quoteandbind.pa.prefill.dob',
        defaultMessage: 'dob'
    },
    gender: {
        id: 'ml.gateway.quoteandbind.pa.prefill.gender',
        defaultMessage: 'gender'
    },
    pfm: {
        id: 'ml.gateway.quoteandbind.pa.prefill.pfm',
        defaultMessage: 'pfm'
    },
    driverActions: {
        id: 'ml.gateway.quoteandbind.pa.prefill.driverActions',
        defaultMessage: 'ACTIONS'
    },
    addDriverButton: {
        id: 'ml.gateway.quoteandbind.pa.prefill.addDriverButton',
        defaultMessage: 'ADD DRIVER'
    },
    driverRemove: {
        id: 'ml.gateway.quoteandbind.pa.prefill.driverRemove',
        defaultMessage: 'Remove'
    },
    driverUndo: {
        id: 'ml.gateway.quoteandbind.pa.prefill.undo',
        defaultMessage: 'Undo'
    },
    vehicleSectionHeader: {
        id: 'ml.gateway.quoteandbind.pa.prefill.vehicleSectionHeader',
        defaultMessage: 'Vehicles'
    },
    noVehiclesP: {
        id: 'ml.gateway.quoteandbind.pa.prefill.noVehiclesP',
        defaultMessage: 'No vehicles are currently covered on this quote.  If none are included, the drivers listed on this quote will be covered for Liability insurance only when they drive vehicles they don\'t own.  If any driver owns a vehicle, please add the vehicle now.'
    },
    addVehicleButton: {
        id: 'ml.gateway.quoteandbind.pa.prefill.addVehicleButton',
        defaultMessage: 'ADD VEHICLE'
    },
    year: {
        id: 'ml.gateway.quoteandbind.pa.prefill.year',
        defaultMessage: 'YEAR'
    },
    make: {
        id: 'ml.gateway.quoteandbind.pa.prefill.make',
        defaultMessage: 'MAKE'
    },
    model: {
        id: 'ml.gateway.quoteandbind.pa.prefill.model',
        defaultMessage: 'MODEL'
    },
    bodyType: {
        id: 'ml.gateway.quoteandbind.pa.prefill.bodyType',
        defaultMessage: 'BODY TYPE'
    },
    trim: {
        id: 'ml.gateway.quoteandbind.pa.prefill.trim',
        defaultMessage: 'TRIM'
    },
    vin: {
        id: 'ml.gateway.quoteandbind.pa.prefill.vin',
        defaultMessage: 'VIN'
    },
    actions: {
        id: 'ml.gateway.quoteandbind.pa.prefill.actions',
        defaultMessage: 'ACTIONS'
    },
    remove: {
        id: 'ml.gateway.quoteandbind.pa.prefill.remove',
        defaultMessage: 'Remove'
    },
    undo: {
        id: 'ml.gateway.quoteandbind.pa.prefill.undo',
        defaultMessage: 'Undo'
    },
    vehicleHasBeenAdded: {
        id: 'ml.gateway.quoteandbind.pa.prefill.vehicleHasBeenAdded',
        defaultMessage: '{vehicle} has been added'
    },
    errorTitle: {
        id: 'ml.gateway.quoteandbind.pa.prefill.error',
        defaultMessage: 'Error'
    },
    hasBeenAdded: {
        id: 'ml.gateway.quoteandbind.pa.prefill.has been added.',
        defaultMessage: 'has been added.'
    },
    hasBeenRemoved: {
        id: 'ml.gateway.quoteandbind.pa.prefill.has been removed.',
        defaultMessage: 'has been removed.'
    },
    AddModalTitle: {
        id: 'ml.gateway.quoteandbind.pa.prefill.Add a new vahicle to your quote',
        defaultMessage: 'Add a new vehicle to your quote' 
    },
    editModalTitle_Ext: {
        id: 'ml.gateway.quoteandbind.pa.prefill.Edit vehicle',
        defaultMessage: 'Edit vehicle' 
    },
    cancelBtn: {
        id: 'ml.quoteandbind.pa.prefill.cancel',
        defaultMessage: 'CANCEL'
    },
    addVehicleBtn: {
        id: 'ml.quoteandbind.pa.prefill.ADD VEHICLE',
        defaultMessage: 'ADD VEHICLE'
    },
    editVehicleBtn_Ext: {
        id: 'ml.quoteandbind.pa.prefill.EDIT',
        defaultMessage: 'EDIT'
    },
    notAValidReasonToRemoveThisDriver: {
        id: 'ml.gateway.quoteandbind.pa.prefill.The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver.  We require this person to be listed as a driver.'
    },
    selfSelected_Ext : {
        id: "ml.quoteandbind.gateway.pa.prefill.Self has already been selected as a relationship to insured on another driver", 
        defaultMessage: "Self has already been selected as a relationship to insured on another driver."
    },
    spouseSelected_Ext : {
        id: "ml.quoteandbind.gateway.pa.prefill.Spouse was already selected as a relationship to insured on another driver", 
        defaultMessage: "Spouse was already selected as a relationship to insured on another driver."
    },
    prefillIncomplete_Ext : {
        id: "ml.quoteandbind.gateway.pa.prefill.Items marked with a (!) need your attention. Please click the edit link and fill out all required fields.", 
        defaultMessage: "Items marked with a (!) need your attention. Please click the edit link and fill out all required fields."
    },
    validate: {
        id: 'ml.gateway.quoteandbind.pa.prefill.validate',
        defaultMessage: 'validate'
    },
    validationNext: {
        id: 'ml.gateway.quoteandbind.pa.prefill.validationNext',
        defaultMessage: 'Next, we\'ll {validate} all information provided'
    },
    vehicles: {
        id: 'ml.gateway.quoteandbind.pa.prefill.vehicles',
        defaultMessage: 'vehicles'
    },
    vehiclesNext: {
        id: 'ml.gateway.quoteandbind.pa.prefill.vehiclesNext',
        defaultMessage: 'We\'ll work on your {vehicles} next'
    },
    crDriversTitle: {
        id:'ml.quoteandbind.pa.wizard.step.CR Drivers',
        defaultMessage: 'Drivers'
    },
    crVehiclesTitle: {
        id:'ml.quoteandbind.pa.wizard.step.CR Vehicles',
        defaultMessage: 'Vehicles'
    },
    somethingWentWrong: {
        id:'ml.quoteandbind.pa.wizard.step.CR Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    closeWindow: {
        id: 'ml.quoteandbind.pa.wizard.step.Close Window',
        defaultMessage: 'Close Window'
    },
    selectDriver: {
        id: 'ml.gateway.quoteandbind.pa.prefill.selectDriver',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    },
    indicativeResponseError: {
        id: 'ml.gateway.quoteandbind.pa.prefill.indicativeResponseError',
        defaultMessage: 'We are unable to retrieve an indicative quote at this time. Please go to ForemostSTAR® for a full rate quote.'
    },
    foremostProducerSearchError: {
        id: 'ml.gateway.quoteandbind.pa.prefill.foremostProducerSearchError',
        defaultMessage: 'Please contact Foremost Agency Contract Management (ACM) at 800-237-6136 for assistance with access to Foremost Choice. (Mon-Fri, 8AM-7PM EST)'
    },
    addSpecialtyVehicleTitle: {
        id: 'ml.gateway.quoteandbind.pa.prefill.addSpecialtyVehicleTitle',
        defaultMessage: 'Add a new specialty vehicle to your quote'
    },
    addSpecialtyVehicleBtn: {
        id: 'ml.gateway.quoteandbind.pa.prefill.addSpecialityVehicleButton',
        defaultMessage: 'ADD SPECIALTY VEHICLE'
    },
    editSpecialtyVehicleTitle: {
        id: 'ml.gateway.quoteandbind.pa.prefill.editSpecialtyVehicleTitle',
        defaultMessage: 'Edit specialty vehicle'
    },
    editSpecialtyVehicleBtn: {
        id: 'ml.gateway.quoteandbind.pa.prefill.editSpecialityVehicleButton',
        defaultMessage: 'SAVE CHANGES'
    },
    specialtyVehicleError: {
        id: 'ml.gateway.quoteandbind.pa.prefill.specialtyVehicleError',
        defaultMessage: 'There was an error processing the request. Please try again later.'
    },
    producerCodeChanged: {
        id: 'ml.gateway.quoteandbind.pa.prefill.producerCodeChanged',
        defaultMessage: 'This producer does not have an active license, appointment, or state authority for this quote. To continue, we have automatically updated the producer code to the primary group producer. If you are a non-licensed (NL) user or would like to be appointed, please contact Agency Contract Management at 1-800-237-6136 for assistance. '
    },
    selectDiffProducerCode: {
        id: 'ml.gateway.quoteandbind.pa.prefill.selectDiffProducerCode',
        defaultMessage: 'Please try selecting a different producer code.'
    }
});